const devBaseURL = "/parliament/api"
const proBaseURL = "/parliament/api"
export const BASE_URL = process.env.NODE_ENV === "development" ? devBaseURL : proBaseURL;
export const TIMEOUT = 300000;